import { exportService, transportRequestService } from '@/_services'
import * as type from './types'
import i18n from '@/i18n'

const actions = {
  fetchShipmentForExport ({ commit }, { shipmentID }) {
    exportService.getShipmentPlannerExport({ shipmentID }).then((response) => {
      commit(type.SET_EXPORT_SHIPMENT, { shipment: response })
    }).catch((error) => {
      console.log(error)
    })
  },
  fetchSelectedShipmentData({ commit, dispatch }, { shipmentID }) {
    commit(type.SHIPMENT_CLEAR_ERROR)
    commit(type.SHIPMENT_FETCHING, { isFetching: true })
    commit(type.CLEAR_SHIPMENT)
    exportService.getShipmentForContextExport({ shipmentID })
    .then((shipment) => {
      commit(type.SET_EXPORT_SHIPMENT_CONTEXT, { shipment })
    })
    .catch((error) => {
      commit(type.SHIPMENT_ERROR, { errors: error })
      console.log(error)
      dispatch('showSnackbar', { message: i18n.t('snackbars.error'), color: 'error' },  { root: true })
    })
    .finally(() => {
      commit(type.SHIPMENT_FETCHING, { isFetching: false })
    })
  },
  fetchTransportRequestData({ commit, dispatch }, { transportID }) {
    commit(type.TRANSPORT_CLEAR_ERROR)
    commit(type.TRANSPORT_FETCHING, { isFetching: true })
    commit(type.CLEAR_TRANSPORT)
    transportRequestService.getTransport(transportID)
    .then((transport) => {
      commit(type.SET_TRANSPORT, { transport })
    })
    .catch((error) => {
      commit(type.TRANSPORT_ERROR, { errors: error })
      console.log(error)
      dispatch('showSnackbar', { message: i18n.t('snackbars.error'), color: 'error' },  { root: true })
    })
    .finally(() => {
      commit(type.TRANSPORT_FETCHING, { isFetching: false })
    })
  },
  addDropUnits ({ commit, dispatch }, { dropID }) {
    commit(type.DROP_CLEAR_ERROR)
    commit(type.DROP_FETCHING, { isFetching: true })
    exportService.getDrop({ id: dropID }).then((response) => {
      commit(type.ADD_DROP_UNITS, { units: response.data.getDrop.children, isTree: false })
      // commit(types.SELECT_DROP_DETAILS_VIEW, { drop: { ...response.data.getDrop.drop, units: response.data.getDrop.children } })
      // commit('UPDATE_SELECTED_RESOURCE', { resource: { ...response.data.getDrop.drop, objectID: response.data.getDrop.id, units: [] } })
      // commit(types.LOADING_NEW_DROPS, { isLoading: false, isExportLoading: true })
    }).catch((error) => {
      commit(type.DROP_ERROR, { errors: error })
      console.log(error)
      dispatch('showSnackbar', { message: i18n.t('snackbars.error'), color: 'error' },  { root: true })
    }).finally(() => {
      commit(type.DROP_FETCHING, { isFetching: false })
    })
  },
  fetchQuoteList ( {commit, dispatch}, { shipmentID }) {
    commit(type.EXPORT_QUOTE_LIST_CLEAR_ERROR)
    commit(type.EXPORT_QUOTE_LIST_FETCHING, { isFetching: true })
    commit(type.EXPORT_CLEAR_QUOTE_LIST)
    exportService.ExportQuotes({shipmentID}).then((response) => {
      // console.log(response)
      commit(type.EXPORT_SET_QUOTE_LIST, { quote: response })
    }).catch((error) => {
      console.log(error)
      commit(type.EXPORT_QUOTE_LIST_ERROR, { errors: error })
      dispatch('showSnackbar', { message: i18n.t('snackbars.error'), color: 'error' },  { root: true })
    }).finally(() => {
      commit(type.EXPORT_QUOTE_LIST_FETCHING, { isFetching: false })
    })
  },
}

export default actions